import React from 'react';
import { Button, Checkbox, FormControlLabel, Grid, Typography } from '@material-ui/core';
import { Formik, Form } from 'formik';

import GuestFieldTable from './GuestFieldTable';
import ClientEditGenericSettings from './ClientEditGenericSettings';
import ClientEditContacts from './ClientEditContacts';
import ClientEditClientSettings from './ClientEditClientSettings';
import ClientEditSiteSettings from './ClientEditSiteSettings';
import ClientEditHotjar from './ClientEditHotjar';
import ClientEditAlice from './ClientEditAlice';
import ClientEditFareharborDirect from './ClientEditFareharborDirect';
import ClientEditLimitationSettings from './ClientEditLimitationSettings';
import ClientDiscountSelector from './ClientDiscountSelector';
import { RouterPrompt } from '../../../../components/atom/RouterPrompt';
import { Alert } from '@material-ui/lab';
import { ErrorIcon } from '../../../../icons';
import { GUEST_FIELD_ERROR_KEY } from './GuestField';
import FormSection from '../../../../components/atom/FormSection';
import ClientEditGoogleAnalytics from './ClientEditGoogeAnalytics';

const headerOptions = Object.freeze([
    { name: 'Arrival date', value: 'arrival_date' },
    { name: 'Departure date', value: 'departure_date' },
    { name: 'Email', value: 'email' },
    { name: 'Phone', value: 'phone' }
]);

const SubmitButton = ({ children, disabled }) => {
    return (
        <Grid item xs={12}>
            <Button
                type="submit"
                disabled={disabled}
                variant="contained"
                color="primary"
                size="large"
                fullWidth
            >
                {children}
            </Button>
        </Grid>
    );
};

export const ClientCreateOrEditForm = ({
    clientId,
    initialValues,
    onSubmit,
    editMode,
    submitClient
}) => {
    const validate = values => {
        const errors = {};

        if (!values.name) {
            errors.name = 'Name is required.';
        }

        if (values.defaultIsland === '' && values.restrictedToOneIsland) {
            errors.restrictedToOneIsland = 'This option needs a default island selected';
        }

        return errors;
    };

    return (
        <Grid container spacing={2}>
            <Formik onSubmit={onSubmit} initialValues={initialValues} validate={validate}>
                {({ isSubmitting, values, setFieldValue, setErrors, errors, dirty }) => (
                    <>
                        <RouterPrompt when={!!dirty && !submitClient} />
                        <Form>
                            <Grid item xs={12}>
                                <Typography variant="h2">
                                    {editMode ? 'Change client data' : 'Add new client'}
                                </Typography>
                            </Grid>
                            <Grid container item spacing={2}>
                                <ClientEditGenericSettings
                                    values={values}
                                    setFieldValue={setFieldValue}
                                />
                                <ClientEditContacts />
                                <ClientDiscountSelector
                                    clientId={clientId}
                                    setFieldValue={setFieldValue}
                                    values={values}
                                />
                                <ClientEditLimitationSettings
                                    values={values}
                                    setFieldValue={setFieldValue}
                                    errors={errors}
                                />
                                {values?.is_vendor && (
                                    <>
                                        <FormSection title="Vendor settings">
                                            <Grid item xs={12} sm={12}>
                                                <FormControlLabel
                                                    label="Send weekly reports by email"
                                                    control={
                                                        <Checkbox
                                                            color="primary"
                                                            checked={values.weeklyReport}
                                                            onChange={e =>
                                                                setFieldValue(
                                                                    'weeklyReport',
                                                                    e.target.checked
                                                                )
                                                            }
                                                        />
                                                    }
                                                />
                                            </Grid>
                                        </FormSection>
                                        <ClientEditFareharborDirect
                                            values={values}
                                            setFieldValue={setFieldValue}
                                        />
                                    </>
                                )}
                                {values.is_client && (
                                    <>
                                        <ClientEditClientSettings
                                            values={values}
                                            setFieldValue={setFieldValue}
                                            errors={errors}
                                        />
                                        <GuestFieldTable
                                            headerFields={values.header_guest_fields}
                                            headerFieldsOptions={headerOptions.concat(
                                                values.guest_fields.map(e => {
                                                    return { name: e.name, value: e.id };
                                                })
                                            )}
                                            guestFields={values.guest_fields}
                                            setHeaderFields={newValue =>
                                                setFieldValue('header_guest_fields', newValue)
                                            }
                                            setGuestFields={newValue =>
                                                setFieldValue('guest_fields', newValue)
                                            }
                                            setErrors={setErrors}
                                            errors={errors}
                                        />
                                        <ClientEditSiteSettings
                                            values={values}
                                            setFieldValue={setFieldValue}
                                        />
                                        <ClientEditHotjar />
                                        <ClientEditGoogleAnalytics />
                                        <ClientEditAlice
                                            values={values}
                                            setFieldValue={setFieldValue}
                                        />
                                    </>
                                )}
                                {Object.values(errors).includes(GUEST_FIELD_ERROR_KEY) && (
                                    <Grid item xs={12}>
                                        <Alert icon={<ErrorIcon />} color="error">
                                            Please check Guest field's availability during
                                            registration.
                                        </Alert>
                                    </Grid>
                                )}
                                <SubmitButton
                                    disabled={isSubmitting || Object.keys(errors).length > 0}
                                >
                                    {editMode ? 'Save changes' : 'Add client'}
                                </SubmitButton>
                            </Grid>
                        </Form>
                    </>
                )}
            </Formik>
        </Grid>
    );
};

export default ClientCreateOrEditForm;
